<template>
    <div class="page">
        <p>
            {{ date }}
        </p>
        <p>
            <b>{{ userStore.user.firstname }} {{ userStore.user.lastname }}</b>
            <br />
            <b>{{ userStore.user.address }}</b>
            <br />
            <b>{{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}</b>
        </p>
        <p>
            <b>{{ creditBureau.address_name }}</b>
            <br />
            <b>{{ address.street }}</b>
            <br />
            <b>{{ address.city }}, {{ address.state_abbreviation }} {{ address.zipcode }}</b>
        </p>
        <p>
            <b>RE: {{ userStore.user.ssn }}</b>
        </p>   
        <p class="letter-content">
            To Whom It May Concern,
        </p>
        <p class="letter-content">
            This letter is a formal complaint that you are reporting inaccurate and incomplete credit information.
        </p>
        <p class="letter-content">
            15 USC 1681e(b) Compliance and procedures
        </p>
        <p class="letter-content">
            <b>(b)Accuracy of report</b>
        </p>
        <p class="letter-content">
            Whenever a consumer reporting agency prepares a consumer report it shall follow reasonable procedures to assure maximum possible accuracy of the information concerning the individual about whom the report relates.
        </p>
        <p class="letter-content">
            Otherwise, anyone paying for your reporting services could fax, mail or email in a fraudulent account.
        </p>
        <p class="letter-content">
            I demand to see verifiable proof (i.e.: an original consumer contract with my signature on it) that you have on file for the account listed below. Or a Certification from the creditor that certified the accuracy and completeness of the information/account.
        </p>
        <p class="letter-content">
            Your failure to positively verify these accounts has hurt my ability to obtain credit. Under the FCRA, unverifiable accounts must be DELETED and if you are unable to provide me a copy of verifiable proof, you must DELETE the account listed below.
        </p>
        <p class="letter-content">
            I demand that the following account be validated or DELETED immediately:
        </p>
        <p v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id)">
            <strong>
                {{ creditor.furnisher_name }} with account number 
                <template v-if="creditor.reference_number">
                    {{ creditor.reference_number }}
                </template>
                <template v-else>
                    {{ creditor.account_number }}
                </template>
            </strong>
            <template v-if="creditor.reason">
                <br />
                {{ creditor.reason }}
            </template>
        </p>
        <p class="letter-content">
            In addition, DELETE all non-account holding inquiries over 30 days old. Also, please add a promotional suppression to my credit file.
        </p>
        <p class="letter-content">
            Under federal law, you have thirty (30) days to complete your re-investigation. Be advised that the description of the procedure used to determine the accuracy and completeness of the information is hereby requested as well, to be provided within fifteen (15) days of the completion of your re-investigation.
        </p>
        <p style="page-break-after: always;">
            Thank you, <br> <br>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}<br />
        </p>
    </div>
    <div class="page-content">
        <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
        <p style="padding-top:3rem; text-align: center;">
            <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
            <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
        </p>
        <p v-if='userStore.user.address_verify_image_url'>
            <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            }
        },
        setup(props) {
            const address = lodash.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore(),
                address,
            };
        }
    };
</script>
